import React, { useContext, useState } from "react";
import { APIContext } from "../../api";
export default function BanUser({ userID, username, data = {}, onChange }) {
  const { setUserBan, setSignupIPBan } = useContext(APIContext);
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const [ipMessage, setIPMessage] = useState("");
  const banIP = async (ip) => {
    if (!window.confirm(`Block new signups from ${ip}? This IP may be shared by other users.`)) return;
    setBusy(true); setError(""); setIPMessage("");
    try {
      await setSignupIPBan(ip, true);
      setIPMessage(`New signups from ${ip} are now blocked.`);
    } catch (error) {
      setError(error.response?.data?.message || "Could not ban this IP.");
    } finally { setBusy(false); }
  };
  const change = async () => {
    const banned = !data.banned;
    if (!window.confirm(banned ? `Ban ${username}? This will block their app login and unpublish all websites they own.` : `Unban ${username}? Their websites will stay unpublished.`)) return;
    setBusy(true); setError("");
    try { onChange(await setUserBan(userID, username, banned)); }
    catch (error) { setError(error.response?.data?.message || "Could not update the ban."); }
    finally { setBusy(false); }
  };
  return <section className="my-5 border border-slate-200 rounded-xl p-4">
    <h3 className="font-semibold">Account ban</h3>
    <p className="text-sm my-2">{data.banned ? "This account is banned." : "Ban this user to block app login and unpublish their owned websites."}</p>
    {data.ban_unpublish_pending && <p className="text-sm mb-3">{data.ban_unpublish_error || "Owned websites are being unpublished. Refresh this page to see the latest status."}</p>}
    <div className="my-4 border-t border-slate-200 pt-4">
      <h4 className="font-semibold text-sm">Recorded IP addresses</h4>
      <p className="text-sm text-slate-500 mt-1">From authenticated dashboard visits. The first recorded IP may be later than signup.</p>
      {[
        ["First recorded IP", data.first_seen_ip, data.first_seen_ip_at],
        ["Latest IP", data.last_seen_ip, data.last_seen_ip_at],
      ].map(([label, ip, at]) => <div key={label} className="flex flex-wrap items-center justify-between gap-3 mt-3">
        <div><p className="text-sm text-slate-500">{label}</p><p className="font-mono text-sm break-all">{ip || "Not recorded yet"}</p>
          {at && <time dateTime={new Date(at).toISOString()} className="text-xs text-slate-500">{new Date(at).toLocaleString()}</time>}
        </div>
        {ip && <button type="button" disabled={busy} onClick={() => banIP(ip)} className="text-sm text-red-700 underline disabled:opacity-50">Ban IP</button>}
      </div>)}
      {ipMessage && <p role="status" className="mt-3 text-sm">{ipMessage} <a href="/signup-ip-bans" className="underline">Manage IP bans</a></p>}
    </div>
    {error && <p role="alert" className="text-red-700 mb-3">{error}</p>}
    <button disabled={busy} onClick={change} className="px-4 py-2 rounded-lg bg-red-700 text-white text-sm font-semibold disabled:opacity-50">{busy ? "Saving…" : data.banned ? "Unban User" : "Ban User"}</button>
  </section>;
}
